/**
 * ToastProvider Component
 * Wraps the app with sonner Toaster for toast notifications.
 */

import React from 'react';
import { Toaster } from 'sonner';

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '0.75rem',
            padding: '1rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
          },
          classNames: {
            toast: 'font-sans',
            title: 'text-slate-900 font-medium',
            description: 'text-slate-600 text-sm',
            success: 'border-l-4 border-l-emerald-500',
            error: 'border-l-4 border-l-red-500',
            info: 'border-l-4 border-l-blue-500',
            warning: 'border-l-4 border-l-amber-500',
          },
        }}
        expand={false}
        richColors
        closeButton
      />
    </>
  );
};

export default ToastProvider;
